/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GeoJSON } from './GeoJSON';
import {
    GeoJSONFromJSON,
    GeoJSONFromJSONTyped,
    GeoJSONToJSON,
} from './GeoJSON';
import type { GroupName } from './GroupName';
import {
    GroupNameFromJSON,
    GroupNameFromJSONTyped,
    GroupNameToJSON,
} from './GroupName';
import type { WatchdogDefinitionPort } from './WatchdogDefinitionPort';
import {
    WatchdogDefinitionPortFromJSON,
    WatchdogDefinitionPortFromJSONTyped,
    WatchdogDefinitionPortToJSON,
} from './WatchdogDefinitionPort';
import type { WatchdogDefinitionShiplist } from './WatchdogDefinitionShiplist';
import {
    WatchdogDefinitionShiplistFromJSON,
    WatchdogDefinitionShiplistFromJSONTyped,
    WatchdogDefinitionShiplistToJSON,
} from './WatchdogDefinitionShiplist';

/**
 * 
 * @export
 * @interface WatchdogDefinition
 */
export interface WatchdogDefinition {
    /**
     * The name of the watchdog
     * @type {string}
     * @memberof WatchdogDefinition
     */
    name?: string;
    /**
     * The id of the watchdog
     * @type {string}
     * @memberof WatchdogDefinition
     */
    id?: string;
    /**
     * The type of watchdog: line, polygon, port, cable or fishing. The request must include a valid object of the defined type.
     * @type {string}
     * @memberof WatchdogDefinition
     */
    type?: string;
    /**
     * 
     * @type {WatchdogDefinitionPort}
     * @memberof WatchdogDefinition
     */
    port?: WatchdogDefinitionPort;
    /**
     * 
     * @type {GeoJSON}
     * @memberof WatchdogDefinition
     */
    polygon?: GeoJSON;
    /**
     * 
     * @type {GeoJSON}
     * @memberof WatchdogDefinition
     */
    line?: GeoJSON;
    /**
     * Access Control list
     * @type {Array<GroupName>}
     * @memberof WatchdogDefinition
     */
    acl?: Array<GroupName>;
    /**
     * Optional filter string
     * @type {string}
     * @memberof WatchdogDefinition
     */
    filter?: string;
    /**
     * 
     * @type {WatchdogDefinitionShiplist}
     * @memberof WatchdogDefinition
     */
    shiplist?: WatchdogDefinitionShiplist;
    /**
     * The template used for generating the message sent by mail and/or SMS when an event is activated. The default depends on the type of event definition. You can use various keywords (surrounded by percent signs) that will be replaced before the message is sent. See the aisWeb online help for a list of keywords.
     * @type {string}
     * @memberof WatchdogDefinition
     */
    activateText?: string;
    /**
     * The template used for generating the message sent by mail and/or SMS when an event is activated. The default depends on the type of event definition. You can use various keywords (surrounded by percent signs) that will be replaced before the message is sent. See the aisWeb online help for a list of keywords.
     * @type {string}
     * @memberof WatchdogDefinition
     */
    deactivateText?: string;
    /**
     * If this is enabled, you can specify minimum and maximum values for Course Over Ground (COG). Only vessels with a COG inside the specified interval will generate events.
     * @type {boolean}
     * @memberof WatchdogDefinition
     */
    checkDirection?: boolean;
    /**
     * See check_direction.
     * @type {number}
     * @memberof WatchdogDefinition
     */
    directionMinAngle?: number;
    /**
     * See check_direction.
     * @type {number}
     * @memberof WatchdogDefinition
     */
    directionMaxAngle?: number;
    /**
     * How many position reports must be received within the area (or on the other side of the line) before an event is activated. The default is 1; higher values are useful in avoiding spurious activation due to GPS errors. On the other hand, a too high value may result in missing or delayed events.
     * @type {number}
     * @memberof WatchdogDefinition
     */
    nofSamples?: number;
    /**
     * How many position reports must be received within the area (or on the other side of the line) before an event is deactivated. The default is 1; higher values are useful in avoiding spurious deactivation due to GPS errors. On the other hand, a too high value may result in missing or delayed events.
     * @type {number}
     * @memberof WatchdogDefinition
     */
    nofSamplesDeactivation?: number;
    /**
     * How many position reports must be received between successive activation events. The default is zero; higher values are useful for avoiding spurious deactivation due to GPS errors. On the other hand, a too high value may result in missing or delayed events.
     * @type {number}
     * @memberof WatchdogDefinition
     */
    samplesBetweenTrigger?: number;
    /**
     * Similar to samples_between_trigger, but based on time (seconds) instead of received AIS reports.
     * @type {number}
     * @memberof WatchdogDefinition
     */
    timeBetweenTrigger?: number;
    /**
     * If a vessel has activated an event, and the system has not received any reports from the vessel for this long, the event will automatically be deactivated (it is assumed that the vessel is no longer in AIS range). The default is never.
     * @type {number}
     * @memberof WatchdogDefinition
     */
    timeoutWhenActive?: number;
    /**
     * This determines the severity of the generated events. Valid values are "note", "warning", "alert".
     * @type {string}
     * @memberof WatchdogDefinition
     */
    severity?: string;
    /**
     * If this box is checked, you must also specify a value for ship_notification_text. When an event is activated, the system will send a Safety Related message to the vessel in question.
     * @type {boolean}
     * @memberof WatchdogDefinition
     */
    sendShipNotification?: boolean;
    /**
     * See send_ship_notification. Note that due to technical limitations in AIS, you can only use certain characters.
     * @type {string}
     * @memberof WatchdogDefinition
     */
    shipNotificationText?: string;
}

/**
 * Check if a given object implements the WatchdogDefinition interface.
 */
export function instanceOfWatchdogDefinition(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WatchdogDefinitionFromJSON(json: any): WatchdogDefinition {
    return WatchdogDefinitionFromJSONTyped(json, false);
}

export function WatchdogDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchdogDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'port': !exists(json, 'port') ? undefined : WatchdogDefinitionPortFromJSON(json['port']),
        'polygon': !exists(json, 'polygon') ? undefined : GeoJSONFromJSON(json['polygon']),
        'line': !exists(json, 'line') ? undefined : GeoJSONFromJSON(json['line']),
        'acl': !exists(json, 'acl') ? undefined : ((json['acl'] as Array<any>).map(GroupNameFromJSON)),
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
        'shiplist': !exists(json, 'shiplist') ? undefined : WatchdogDefinitionShiplistFromJSON(json['shiplist']),
        'activateText': !exists(json, 'activate_text') ? undefined : json['activate_text'],
        'deactivateText': !exists(json, 'deactivate_text') ? undefined : json['deactivate_text'],
        'checkDirection': !exists(json, 'check_direction') ? undefined : json['check_direction'],
        'directionMinAngle': !exists(json, 'direction_min_angle') ? undefined : json['direction_min_angle'],
        'directionMaxAngle': !exists(json, 'direction_max_angle') ? undefined : json['direction_max_angle'],
        'nofSamples': !exists(json, 'nof_samples') ? undefined : json['nof_samples'],
        'nofSamplesDeactivation': !exists(json, 'nof_samples_deactivation') ? undefined : json['nof_samples_deactivation'],
        'samplesBetweenTrigger': !exists(json, 'samples_between_trigger') ? undefined : json['samples_between_trigger'],
        'timeBetweenTrigger': !exists(json, 'time_between_trigger') ? undefined : json['time_between_trigger'],
        'timeoutWhenActive': !exists(json, 'timeout_when_active') ? undefined : json['timeout_when_active'],
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
        'sendShipNotification': !exists(json, 'send_ship_notification') ? undefined : json['send_ship_notification'],
        'shipNotificationText': !exists(json, 'ship_notification_text') ? undefined : json['ship_notification_text'],
    };
}

export function WatchdogDefinitionToJSON(value?: WatchdogDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'type': value.type,
        'port': WatchdogDefinitionPortToJSON(value.port),
        'polygon': GeoJSONToJSON(value.polygon),
        'line': GeoJSONToJSON(value.line),
        'acl': value.acl === undefined ? undefined : ((value.acl as Array<any>).map(GroupNameToJSON)),
        'filter': value.filter,
        'shiplist': WatchdogDefinitionShiplistToJSON(value.shiplist),
        'activate_text': value.activateText,
        'deactivate_text': value.deactivateText,
        'check_direction': value.checkDirection,
        'direction_min_angle': value.directionMinAngle,
        'direction_max_angle': value.directionMaxAngle,
        'nof_samples': value.nofSamples,
        'nof_samples_deactivation': value.nofSamplesDeactivation,
        'samples_between_trigger': value.samplesBetweenTrigger,
        'time_between_trigger': value.timeBetweenTrigger,
        'timeout_when_active': value.timeoutWhenActive,
        'severity': value.severity,
        'send_ship_notification': value.sendShipNotification,
        'ship_notification_text': value.shipNotificationText,
    };
}

